import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { useThemedStyles, type ThemeColors } from "~/styles/theme";

export function CenteredScreen({ children }: { children: ReactNode }) {
  const stylesheet = useThemedStyles(makeStyles);
  return <View style={stylesheet.screen}>{children}</View>;
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    screen: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.background,
    },
  });
